export * from 'server/models/Share';


// WEBPACK FOOTER //
// ./data/models/Share.ts